module.exports = __webpack_public_path__ + "static/media/menu-boczne-zporady_BLUE.7ea7511e.svg";